import { NgModule } from '@angular/core';
import { UnescapePipe } from './unescape.pipe';

@NgModule({
  declarations: [UnescapePipe],
  exports: [UnescapePipe],
})
export class UnescapePipeModule {}
